import { render, staticRenderFns } from "./DisclaimerFootnote.vue?vue&type=template&id=de5a313a"
import script from "./DisclaimerFootnote.vue?vue&type=script&lang=js"
export * from "./DisclaimerFootnote.vue?vue&type=script&lang=js"
import style0 from "./DisclaimerFootnote.vue?vue&type=style&index=0&id=de5a313a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports